import { useEffect } from 'react';
import { navigate } from 'gatsby';

const useOatStorageCheck = ({ initialStorage, updateOatState, removeAllItems, page }) => {
  useEffect(() => {
    if (initialStorage?.clientId) {
      updateOatState(initialStorage);
    } else {
      removeAllItems();
      if (page && page === 'faqs') {
        updateOatState({ previousPage: '/', page });
      }
      if (page && page === 'join-table') {
        updateOatState({ previousPage: '/', page });
      } else {
        navigate('/', { replace: true });
      }
    }
    // eslint-disable-next-line no-autofix/react-hooks/exhaustive-deps
  }, [initialStorage, page]);
};

export default useOatStorageCheck;
